exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.section-row-select[data-v-28c9ea6c] {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n.section-field[data-v-28c9ea6c],\n.row-field[data-v-28c9ea6c],\n.quantity-field[data-v-28c9ea6c] {\n  flex: 1;\n}\n.quantity-field[data-v-28c9ea6c] {\n  min-width: 140px;\n}\n", ""]);

// exports
